import c from 'classnames';
import { ButtonColors, DesignButton, TextLink, Typography } from 'components';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHasModalOpened, setModalOpened } from 'store/modal';

import styles from './MarketingBanner.module.scss';



interface MarketingBannerProps {
  text?: string;
  linkUrl?: string;
  isDismissable?: boolean;
  onDismiss?: () => void;
  modalIdentifier: { name: string; props: { [key: string]: string | undefined } };
}

const MarketingBanner = forwardRef<HTMLDivElement, MarketingBannerProps>(
  (
    {
      text,
      linkUrl,
      isDismissable = true,
      onDismiss,
      modalIdentifier,
    },
    ref,
  ) => {
  const dispatch = useDispatch();
  // NOTE: This component isn't a modal. But this is the only way we have (so far) to handle a persistent dismiss.
  const isAnnouncementDismissed = useSelector(
    getHasModalOpened(modalIdentifier),
  );
  const dismiss = () => {
    dispatch(setModalOpened(modalIdentifier));
    onDismiss?.();
  };
  if (isAnnouncementDismissed) {
    return null;
  }

  return (
    <div className={c(styles.container)} ref={ref}>
      <div className={styles.content}>
        {text && (
          <Typography variant='body-s' className={styles.text}>
            {text}
          </Typography>
        )}
        {linkUrl && (
          <TextLink
            label=''
            to={linkUrl}
            iconNameRight='chevronForward'
            target='_blank'
            rel='noopener noreferrer'
          />
        )}
      </div>
      {isDismissable && (
        <DesignButton
          variant='wrapper'
          label=''
          color={ButtonColors.PURPLE}
          iconNameLeft='closeSm'
          onClick={dismiss}
        />
      )}
    </div>
  );
});

export default MarketingBanner;
